import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/offer';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream-50" aria-labelledby="faq-titulo" data-id="element-17" data-mp="1bmvcovcc04q6">
      <div className="mx-auto max-w-3xl px-5 py-16 lg:py-24" data-id="element-18" data-mp="1gk58csqbdcmg">
        <p className="mb-3 text-center text-sm font-semibold uppercase tracking-[0.16em] text-clay-600" data-id="element-19" data-mp="248xy27gceo8m">
          Preguntas frecuentes
        </p>
        <h2 id="faq-titulo" className="text-center font-display text-3xl font-bold text-forest-900 sm:text-4xl" data-id="element-20" data-mp="28cvyclhem539">
          Resolvamos tus últimas dudas
        </h2>

        <ul className="mt-10 space-y-3" data-id="element-21" data-mp="1zgn19dgwfika">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className="overflow-hidden rounded-2xl border border-cream-300 bg-white" data-id="element-22" data-mp="2rzabtyy9rf74" data-mpi={index}>
                <h3 data-id="element-23" data-mp="14t7ib3sa8lsw">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-clay-400" data-id="element-24" data-mp="10tys28wgb623">
                    <span className="font-semibold text-forest-900" data-id="element-25" data-mp="1jkzputlu4vk2">{faq.question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-clay-500 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-26" data-mp="1xkhjpndzmz0a" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-27" data-mp="3udawfuarqyvj">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeOut'
              }} data-id="element-28" data-mp="1y9wix25qivl3">
                      <p className="px-5 pb-5 leading-relaxed text-forest-800/80" data-id="element-29" data-mp="2c6rt4xxq2t2q">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}